import ViewsResource from './views-resource';

const URL = '/market-stats';

export default function AccountResources({ base }) {
  return {
    Views: ViewsResource({ base, statUrl: URL }),
  };
}
